<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Traitements
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      v-for="traitement in traitementsModifiable"
      :key="traitement.id"
      class="d-flex flex-column mt-6 mx-4"
      @click="openModalAbonnement()"
    >
      <AgrialSelect
        v-if="traitement.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement"
        v-model="traitement.valeurSaisie"
        :items="valeurEcos"
        :label="traitement.comparateurMargeParametre.typeRubrique.libelleSousRubrique"
        hide-details
        :class="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor-pointer' : 'cursor-no-drop'"
        :readonly="!isCulturialAbonne || !hasDroitEcriture"
      >
        <template
          v-if="!isCulturialAbonne"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            :style="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor: pointer;' : 'cursor: no-drop;'"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialSelect>
      <AgrialSelect
        v-else
        v-model="traitement.valeurSaisie"
        :items="listeChoixPressions(traitement)"
        :label="traitement.comparateurMargeParametre.typeRubrique.libelleSousRubrique"
        :class="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor-pointer' : 'cursor-no-drop'"
        :readonly="!isCulturialAbonne || !hasDroitEcriture"
        hide-details
      >
        <template
          v-if="!isCulturialAbonne"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            :style="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor: pointer;' : 'cursor: no-drop;'"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialSelect>
    </div>

    <BaseMessage
      class="mx-5 mt-3"
      color="primary"
      text
      type="info"
    >
      Indicateur de pression : {{ computeIndicateurPressionMoyenne }}
    </BaseMessage>

    <div class="d-flex mx-4 mt-4 justify-space-between">
      <AgrButton
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="loading || !isCulturialAbonne || !hasDroitEcriture"
        :loading="loading"
        @click="saveParametre()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>
<script>
import { AgrButton } from '@agrial/ui'
import AgrialSelect from '@/components/form/agrial-select.vue'
import BaseMessage from '@/components/common/base-message.vue'
import {clone} from '@/utils/clone'

export default {
  name: 'UpdateParametreModal',
  components: {AgrButton,  AgrialSelect,  BaseMessage},
  props: {
    traitements: {
      type: Array,
      default: () => []
    },
    indicateurPression: {
      type: String,
      required: true
    },
    isCulturialAbonne: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasDroitEcriture: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      traitementsModifiable: null,
      erreur: null,
      valeurEcos: ['Oui', 'Non']
    }
  },

  computed: {
    computeIndicateurPressionMoyenne () {
      let result
      let sommeCoefficients = 0
      let coefficient = 0
      let traitements = this.traitementsModifiable.filter(e => !e.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement)
      traitements.forEach(element => {
        if (element.valeurSaisie === 'Pression faible') {
          coefficient = 1
        } else if (element.valeurSaisie === 'Pression moyenne') {
          coefficient = 2
        } else {
          coefficient = 3
        }
        sommeCoefficients += coefficient
      })
      let calcul = sommeCoefficients / traitements.length
      if (calcul === 1) {
        result = 'Faible'
      } else if (calcul > 1 && calcul < 2) {
        result = 'Faible à moyenne'
      } else if (calcul === 2) {
        result =  'Moyenne'
      } else if (calcul > 2 && calcul < 3) {
        result =  'Moyenne à forte'
      } else if (calcul === 3) {
        result =  'Forte'
      } else {
        result =  ''
      }
      return result
    },
  },

  created () {
    this.traitementsModifiable = clone(this.traitements)
    this.traitementsModifiable = this.traitementsModifiable.filter(e => e.valeurSaisie != null)
    this.traitementsModifiable.filter(e => e.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement).map(e => {
      e.valeurSaisie = e.valeurSaisie > 0 ? 'Oui' : 'Non'
    })

    this.traitementsModifiable.filter(e => !e.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement).map(e => {
      e.valeurSaisie = e.pressionSaisie
    })
  },

  methods: {
    listeChoixPressions (parametre) {
      let result = []
      if (parametre.comparateurMargeParametre.valeurAdmin.minimum != null) {
        result.push('Pression faible')
      }
      if (parametre.comparateurMargeParametre.valeurAdmin.valeur != null) {
        result.push('Pression moyenne')
      }
      if (parametre.comparateurMargeParametre.valeurAdmin.maximum != null) {
        result.push('Pression forte')
      }
      return result
    },
    onClose () {
      this.$emit('close')
    },
    saveParametre () {
      let traitementUpdated = clone(this.traitementsModifiable)
      traitementUpdated.forEach(element => {
        if (element.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement) {
          element.valeurSaisie = element.valeurSaisie === 'Oui' ? element.comparateurMargeParametre.valeurEconomique : 0
        } else {
          element.pressionSaisie = element.valeurSaisie
          if (element.valeurSaisie === 'Pression faible') {
            element.valeurSaisie = element.comparateurMargeParametre.valeurAdmin.minimum
          } else if (element.valeurSaisie === 'Pression forte') {
            element.valeurSaisie = element.comparateurMargeParametre.valeurAdmin.maximum
          } else {
            element.valeurSaisie = element.comparateurMargeParametre.valeurAdmin.valeur
          }
        }
      })
      this.$emit('updateParametre', traitementUpdated)
    },
    openModalAbonnement () {
      if (!this.isCulturialAbonne) {
        this.$emit('openModalAbonnement')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.prepend-icon {
  z-index: 100;
}
.cursor-pointer {
  ::v-deep.v-input--is-readonly input {
    cursor:pointer;
  }
}
.cursor-no-drop {
  ::v-deep.v-input--is-readonly input {
    cursor:no-drop;
  }
}
</style>